import React, {Component} from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import CKEditor from "react-ckeditor-component";
import $ from 'jquery';
import Header from './../../Header';
import HeaderMob from './../../HeaderMob';
import Profile_img from './../../assets/images/img.jpg';
import MuiThemeProvider   from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme        from 'material-ui/styles/getMuiTheme';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
class ViewTodo extends Component {
    constructor(props){
        super(props);
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.state = {
            todo:'',
            todos: [],
            notes:[],
            note:'',
            owners: [],
            images:'',
            todo_history:[],
            message:'',
            owner:'',
            user_id:'',
            id_user:'',
            owner_to:'',
            visibility:'',
            status:'',
            owner_cc:'',
            fields: {},
            errors: {},
            apiUrl: this.decryptconfigdata('apiUrl'),
            userEmail: has_local_data ? localdata.user_email : '',
            userId: has_local_data ? localdata.user_id : '',
            userName: has_local_data ? localdata.user_name : '',
            userAuthKey: has_local_data ? localdata.user_key : '',
            todo_attachments: [],
            todoNote_attachments: [],
            internal_owner: '',
            formatted_owners: [],
            priority: '',
            status: '',
        }
            this.ckOnChange = this.ckOnChange.bind(this);
            this.showImage = this.showImage.bind(this);
            this.getSelectedOwner = this.getSelectedOwner.bind(this);
            this.getSelectedCcOwner = this.getSelectedCcOwner.bind(this);
            this.getAllOwners = this.getAllOwners.bind(this); 
            this.handleChange = this.handleChange.bind(this);
            this.alertEditMessage = this.alertEditMessage.bind(this);
    }

    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }
        
    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }

    getTodoDetails() {
        $(document).ready(function () {
            $('.loader-new').removeClass('hidden');
            $('.intranet_body').addClass('hidden');
        });
        fetch(this.state.apiUrl + '/TodoRest/Viewtodo/id/' + this.props.match.params.todoId + '/userId/' + this.state.userId + '/userAuthKey/' + this.state.userAuthKey)
            .then((Response) => Response.json())
            .then((responseJson) => {
                responseJson = this.decrypt(responseJson, 1);
                $(document).ready(function () {
                $('.loader-new').addClass('hidden');
                $('.intranet_body').removeClass('hidden');
            });
                console.log(responseJson)  
                this.setState({
                    todo:responseJson.todo,
                    todos:responseJson.todos,
                    notes:responseJson.notes,
                    todo_history: responseJson.todo_history,
                    ownername:responseJson.ownername,
                    userid : responseJson.userid,
                    error : responseJson.error,
                    id_error : responseJson.id_error,
                    todo_attachments : responseJson.todo_attachments,
                    todoNote_attachments: responseJson.todoNote_attachments,
                    config:responseJson.config,
                    formatted_owners:responseJson.formatted_owners,
                }) 
                
        })
    }

    AddNote(e){
        document.getElementById("add_note").innerHTML="Sending....";
        let img = document.getElementById('attachments').files.length;
        const fd = new FormData;
       if(img>0){
       for (var x = 0; x < img; x++) {
            fd.append("image[]", document.getElementById('attachments').files[x]);
        }
       }
        //document.getElementById("add_note").disabled = true;
        fd.append('ticket_inputs', JSON.stringify(this.state));
        fetch(this.state.apiUrl +'/TodoRest/AddNoteTodo/userAuthKey/'+ this.state.userAuthKey+'/userId/'+this.state.userId,{
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                document.getElementById("add_note").innerHTML = "Add Note";
                if (findresponse.code == 200) {
                    this.setState({ message: findresponse.msg }, function () {
                        window.location.href = '/viewTodo/' + this.state.todo.id;
                    }); 
                } else {
                
                    this.setState({message:findresponse.msg}) 
                }
        })
}

ckOnChange(evt){
        console.log("onChange fired with event info: ", evt);
        var ckContent = evt.editor.getData();
        this.setState({
        note: ckContent
        })
    }
showImage(s3url) {
    window.open(s3url);
}

addTodoDetails() {
    fetch(this.state.apiUrl + '/TodoRest/Adddetails/userAuthKey/'+ this.state.userAuthKey, {
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(this.state),
    })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                this.setState({
                    owners: findresponse.owner,
                    priority: findresponse.priority,
                    status: findresponse.status,
             
                })
            })
}
onChangeowner(propertyName,event){
    const todo = this.state.todo;
    todo[propertyName] = event.target.value;
    this.setState({ todo: todo });
}
handleChangeTo = (event, index, internal_owner) => {

    let fields = this.state.fields;
    this.setState({ internal_owner: internal_owner });
    //fields['candidate_profiles'] = value.length;
}
handleChange = (event, index, internal_cc) => {

    let fields = this.state.fields;
    this.setState({ internal_cc: internal_cc });
    //fields['candidate_profiles'] = value.length;
}

componentWillMount(){
        document.title = "Intranet | Todo Details";
        if(!localStorage.getItem('userLogin')){     
            this.setState({redirect:true});
        }
          
       
        this.getTodoDetails(); 
        this.addTodoDetails(); 
        this.getAllOwners();
        $(document).ready(function () {
            if (window.File && window.FileList && window.FileReader) {
            $("#files").on("change", function(e) {
            var files = e.target.files, 
            filesLength = files.length;
            });
            } else {
            alert("Your browser doesn't support to File API")
            }
            $('.upload_btn label').click(function(){
                $(this).parent().find('.inputfile').click();
            });
            $( '.inputfile' ).each( function()
        {
            var $input	 = $( this ),
                $label	 = $input.next( 'label' ),
                labelVal = $label.html();
        
            $input.on( 'change', function( e )
            {
                var fileName = '';
        
                if( this.files && this.files.length > 1 )
                    fileName = ( this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length );
                else if( e.target.value )
                    fileName = e.target.value.split( '\\' ).pop();
        
                if( fileName )
                    $label.find( 'span' ).html( fileName );
                else
                    $label.html( labelVal );
            });
        
            // Firefox bug fix
            $input
            .on( 'focus', function(){ $input.addClass( 'has-focus' ); })
            .on( 'blur', function(){ $input.removeClass( 'has-focus' ); });
        });
        //Show More
    $('.show-more').on('click', function() {
		if($(this).parent().find('.hide_mob').hasClass('active')){
			$(this).parent().find('.hide_mob').removeClass('active');
		}
		else{
			$(this).parent().find('.hide_mob').addClass('active');
		}
		$('.show-more span').text() === 'Show Less' ? $('.show-more span').text('Show More') : $('.show-more span').text('Show Less');
		$('.show-more .fa').toggleClass('active');
	});
            });
            
    }
    getAllOwners() {
        fetch(this.state.apiUrl + '/ticketRest/getOwners/userAuthKey/' + this.state.userAuthKey)
            .then((Response) => Response.json())
            .then((responseJson) => {
                responseJson = this.decrypt(responseJson, 1);
            this.setState({
                hrowners: responseJson
            }) 
    })
    }
    renderOwnerList () {
        if (this.state.hrowners) {
            return (
                  <MuiThemeProvider muiTheme={getMuiTheme()}>
                        <SelectField
                            multiple
                            fullWidth={true}
                            value={this.state.internal_owner}
                            onChange={this.handleChangeTo}
                            maxHeight={200}
                            className="multi"
                            placeholder="name"
                        >
                            {this.state.hrowners.map((owner, i) =>
                                <MenuItem
                                className="multi_drop"
                                    value={owner.email} key={owner.email} primaryText={owner.name} />)}
                        </SelectField>
                  </MuiThemeProvider>
            )
          }
          return <p>Loading owner...</p>
    }
    renderCcOwnerList () {
        if (this.state.hrowners) {
           return (
                 <MuiThemeProvider muiTheme={getMuiTheme()}>
                             <SelectField
                                 multiple
                                 fullWidth={true}
                                 value={this.state.internal_cc}
                                 onChange={this.handleChange}
                                 maxHeight={200}
                                 className="multi"
                                 placeholder="name"
                             >
                                 {this.state.hrowners.map((owner, i) =>
                                     <MenuItem
                                     className="multi_drop"
                                         value={owner.email} key={owner.email} primaryText={owner.name} />)}
                             </SelectField>
                 </MuiThemeProvider>
           )
         }
         return <p>Loading owner...</p>
       }
getSelectedOwner()
{
    var selectedValues = [];    
    $("#singlelistSelect :selected").each(function(){
        selectedValues.push($(this).val()); 
    });
    this.setState({internal_owner:selectedValues});
    // alert(selectedValues);
    
}

getSelectedCcOwner()
      {
        var selectedCcValues = [];    
        $("#ccselectlist :selected").each(function(){
            selectedCcValues.push($(this).val()); 
        });
       // alert(selectedCcValues);
        this.setState({owner_cc:selectedCcValues});
      }

      getReporter(){
        if(this.state.userid){
            return(
                <div>
                {this.state.formatted_owners[this.state.userid]}
                <div class="pro_image pull-left">
                    {/* <img src={this.state.formatted_owners[this.state.userid].attachment_url + this.state.formatted_owners[this.state.userid].attachment} /> */}
                </div>
                </div>
            )
        }
        
    }

    getViewdetails(){
        if(this.state.loading){
            return (
               <div>
                <div class="loader-new"></div>
              </div>
            )
         }else{
        return(
            <div class="form-section border-bottom ">
                <div class="details">
                    <div class="details_title">Title:</div>
                    <div class="details_des"><div dangerouslySetInnerHTML={{__html:this.state.todo.title}} /></div>
                </div>
                <div class="details">
                    <div class="details_title">Descriptions:</div>
                    <div class="details_des"><div dangerouslySetInnerHTML={{__html:this.state.todo.description}} /></div>
                </div>
                <div class="details">
                    <div class="details_title">Attached File</div>
                    <div class="details_des">
                    {
                        this.state.todo_attachments.map((data, key) => 
                        <div class="attached" onClick={() => this.showImage(data.url)}  >
                        <i class="far fa-file"></i>{data.attachment_name}
                        </div>
                    )}
                
                </div>
                </div>
            </div>

        )
    }
}
alertEditMessage(todoid){
    fetch(this.state.apiUrl + '/TodoRest/AlertEditMessage/id/'+todoid+'/userId/'+this.state.userId+'/userAuthKey/'+ this.state.userAuthKey, {
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(this.state),
    })
    .then((Response) => Response.json())
            .then((responseJson) => {
                responseJson = this.decrypt(responseJson, 1);
                if (responseJson.id_error == 0) {
                    window.location.href = '/updateTodo/' + todoid;
                } else {
                            window.location.href = '/Unauthorized';
                        }
    })  
}

    render(){
        if(this.state.redirect) {
            return (
              <Redirect to={'/login'} />
            )
        }
        //console.log(this.props.match.params.todoId);
        return(
            <div>
                <Header brecum_name="To Do" brecum_page="To Do Detail"/>
            <div class="right_col">
            <div class="ticket_list">
            <div class="loader-new"></div>
            <div className="intranet_body hidden">
            <div class="title mob"><HeaderMob page_name="To Do Detail"/>
                <div class="edit pull-right hidden-md">
                    <a onClick={event=> {this.alertEditMessage(this.state.todo.id)}}><i class="fa fa-pencil-square-o"></i></a>                                    
               </div>
            </div>
            <div class="top-row border-bottom hidden-xs">
                <div class="left-section btn-muvi pull-left">
                <button  className="btn btn-sky" onClick={()=> this.alertEditMessage(this.state.todo.id)}>Edit To Do</button>                                    
                <Link to={`/todos/`} name={"max"}> <button className="btn btn-blue hidden-sm" >Back</button></Link>
                </div>	
		    </div>
            {/* <div class="form-section border-bottom ">
                <div class="details">
                    <div class="details_title">Title:</div>
                    <div class="details_des">{this.state.todo.title}</div>
                </div>
                <div class="details">
                    <div class="details_title">Descriptions:</div>
                    <div class="details_des">{this.state.todo.description}</div>
                </div>
                <div class="details">
                    <div class="details_title">Attached File</div>
                    <div class="details_des">
                    {
                        this.state.todo_attachments.map((data, key) => 
                        <span class="color-sky" onClick={() => this.showImage(data.url)}  >
                        {data.attachment_name}
                        </span>
                    )}
                
                </div>
                </div>
            </div> */}
        {this.getViewdetails()}
        <div class="form-section ticket_details border-bottom">
        
        <div class="row">
            <div class="col-md-4 col-xs-12 ticket-1st">
                <div class="details row">
                    <div class="col-md-5 col-xs-6 ticket_label"><span class="bold">#TD ID :</span></div>
                    <div class="col-md-7 col-xs-6 ticket_content">{this.state.todo.id}</div>
                </div>
                <div class="details row">
                    <div class="col-md-5 col-xs-6 ticket_label"><span class="bold">Owner :</span></div>
                    <div class="col-md-7 col-xs-6 ticket_content owner">{this.state.ownername?this.state.ownername:'--'}</div>
                </div>
                <div class="details row">
                    <div class="col-md-5 col-xs-6 ticket_label"><span class="bold">Priority :</span></div>
                    <div class="col-md-7 col-xs-6 ticket_content">{this.state.todo.priority?this.state.config.priority[this.state.todo.priority]:'--'}</div>
                </div>
                <div class="details row">
                    <div class="col-md-5 col-xs-6 ticket_label"><span class="bold">Related To :</span></div>
                <div class="col-md-7 col-xs-6 ticket_content owner">{this.state.todo.related_to?<a href={`/viewTodo/${this.state.todo.related_to}`} name={"max"}> {this.state.todo.related_to}</a>:''}</div>
                </div>
            </div>
            <div class="col-md-4 col-xs-12 ticket-2nd hide_mob">
                <div class="details row">
                    <div class="col-md-5 col-xs-6 ticket_label"><span class="bold">Reported By :</span></div>
                    <div class="col-md-7 col-xs-6 ticket_content">{this.state.userid}</div>
                </div>
                <div class="details row">
                    <div class="col-md-5 col-xs-6 ticket_label"><span class="bold">Reported On :</span></div>
                    <div class="col-md-7 col-xs-6 ticket_content">{this.state.todos.created_date}</div>
                </div>
                <div class="details row">
                    <div class="col-md-5 col-xs-6 ticket_label"><span class="bold">Start Date :</span></div>
                    <div class="col-md-7 col-xs-6 ticket_content">{this.state.todos.start_date!='00-00-0000' && this.state.todos.start_date!=''?this.state.todos.start_date:'--'}</div>
                </div>
            </div>
            <div class="col-md-4 col-xs-12 ticket-3rd hide_mob">
                <div class="details row">
                    <div class="col-md-5 col-xs-6 ticket_label"><span class="bold">Status :</span></div>
                    <div class="col-md-7 col-xs-6 ticket_content">{this.state.todo.status?this.state.config.status[this.state.todo.status]:'--'}</div>
                </div>
                <div class="details row">
                    <div class="col-md-5 col-xs-6 ticket_label"><span class="bold">Visibility :</span></div>
                    <div class="col-md-7 col-xs-6 ticket_content owner">{this.state.todo.visibility?this.state.todo.visibility:'public'}</div>
                </div>
                <div class="details row">
                    <div class="col-md-5 col-xs-6 ticket_label"><span class="bold">ETA :</span></div>
                    <div class="col-md-7 col-xs-6 ticket_content">{this.state.todos.ETA!='00-00-0000' && this.state.todos.ETA!=''?this.state.todos.ETA:'--'}</div>
                </div>
            </div>
            <div class="show-more hidden-md"><i class="fa fa-angle-double-down"></i><span>Show More</span></div>
        </div>
        </div>
        <div className="feedback">
            <h5 class="title"><span>Add Note</span></h5>
            <div class="form-section ticket_details row border-bottom">
            <div className="col-md-6 col-xs-12">
                To: {this.renderOwnerList()}
            </div>
            <div className="col-md-6 col-xs-12">
                Cc: {this.renderCcOwnerList()}
            </div>
            <div class="clearfix"></div>
            <div className="form-section ckeditor">
            <CKEditor 
              activeClass="p10" 
              content={this.state.note} 
              events={{
                "change": this.ckOnChange
              }}
             />
             <span style={{color: "red"}}>{this.state.message}</span>
             <span style={{color: "red"}}>{this.state.errors["note"]}</span>
             </div>
            <div class="form-section ckeditor_upload">
            <div class="upload">
                <label>Add Attachment :</label>
                <div class="upload_btn">
                    <input type="file" name="attachments" id="attachments" class="inputfile inputfile-1" data-multiple-caption="{count} files selected" multiple/>
                    <label for="file-1">
                        <i class="fa fa-plus hidden-sm" aria-hidden="true"></i>
                        <span>Choose file</span>
                        <i class="fa fa-cloud-upload-alt hidden-md" aria-hidden="true"></i>
                    </label>
                </div>
            </div>
            </div>
            <div className="form-section ckeditor">
                <button type="submit" name="add_note" id="add_note" className="btn btn-sky mob-btn" onClick={()=> this.AddNote()}>Add Note</button>
            </div>
            </div>
        </div>
        <div className="add_note_history">
            <div className="feedback">
              {this.state.notes.length>'0'?
              <h5 class="title"><span>View Note</span></h5>:''}
              {this.state.message1}
                {
                    this.state.notes.map((data,key)=>
                    <div class="sub_feedback" id={'note' + data.id}>
                        <div class="main">
                        <div class="pro_image">
                       {this.state.formatted_owners[data.id_user].attachment_url? <img src = {this.state.formatted_owners[data.id_user].attachment_url+this.state.formatted_owners[data.id_user].attachment}/>:<span class = "profile_first_name">{this.state.formatted_owners[data.id_user].img_name}</span>}
                       {/* <img src = {Profile_img} /> */}
                        </div>
                        <h6>{data.owner_name}</h6>
                        <span>{data.created_date}</span>
                        </div>
                    <div class="sub">
                        <a href={'#note' + data.id} key={key} to={data.id} name={'note' + data.id}><h6>Note {data.id}</h6></a>
                        <div dangerouslySetInnerHTML={{__html:data.note}} />
                        {this.state.todoNote_attachments[data.id] ?
                        <div>
                        {
                            this.state.todoNote_attachments[data.id].map((data, key) => 
                            <div class="attached" onClick={() => this.showImage(data.url)}  >
                            <i class="far fa-file"></i>{data.attachment_name}
                            </div>
                        )}
                        </div>
                        :''
                        }
                    </div>
                    </div>
                    )
                }
             </div>
            <div class="tickets">
                <h5 class="title"><span>Todo History</span></h5>
                    <ul class="tickets_head">
                        <li class="intra_col_25">Data</li>
                        <li class="intra_col_25">User</li>
                        <li class="intra_col_25">Field</li>
                        <li class="intra_col_25">Content</li>
                    </ul>
                    {
                    this.state.todo_history.map((todoHistory,key)=>
                    
                    <ul class="tickets_number">
                        <li class="intra_col_25">{todoHistory.created_date } </li>
                        <li class="intra_col_25"> {todoHistory.user_name}</li>
                        <li class="intra_col_25">{todoHistory.field} => {todoHistory.action}</li>
                        <li class="intra_col_25"> {((todoHistory.field=='title') || (todoHistory.field=='description')) ? (<Link to={`/TodoHistoryDetails/${todoHistory.id}`} name={"max"}><span className="color-sky">View details</span></Link>):todoHistory.object_content}</li>
                    </ul>
                        )
                    }
    
			</div>
            </div>
            </div>
            </div>
            </div>
            </div>
            
        )
    }
}

export default ViewTodo;



// WEBPACK FOOTER //
// ./src/components/todo/viewTodo.js